// src/pages/EmployerJobs.js

import React, { useEffect, useState } from "react";
import $ from "jquery";
import "datatables.net-bs4";
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
import { useNavigate, useLocation } from "react-router-dom";
import { formatDateSafe } from "../../../utils/dateUtils";

import api from "../../../api/axios";
import jbAPI from "../../../api/jobboard";
import JobForm from "../../../components/employer/JobForm";


const ManageJobs = () => {
  const location = useLocation();
  const [jobs, setJobs] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editJobData, setEditJobData] = useState(null);
  const [message, setMessage] = useState({ type: "", text: "" });
  const navigate = useNavigate();

  useEffect(() => {
     const timer = setTimeout(() => {
      $('#jobListTable').DataTable();
    }, 1000); // wait for DOM to render

    // return () => {
    //   // destroy on cleanup to avoid reinitialization errors
    //   $('#jobListTable').DataTable().destroy(true);
    //   clearTimeout(timer);
    // };
 
  
    const fetchJobs = async () => {
      try {
        const token = localStorage.getItem("otoken");
        const companyId = localStorage.getItem("companyId");

        if (!token || !companyId) {
          console.warn("Missing token or companyId");
          return;
        }

        let endpoint = `/employer/company/${companyId}/jobs`;

        // Optional: differentiate views if needed
        if (location.pathname === "/employer/job-management/your-jobs") {
          endpoint = `/employer/company/${companyId}/jobs?scope=own`;
        }

        const response = await jbAPI.get(endpoint, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        setJobs(response.data.jobs);
      } catch (error) {
        console.error("Failed to fetch jobs:", error);
      }
    };


    fetchJobs();
  }, []);

 

  const handleCreateJob = (formData) => {
    // Send formData to your API or state
    console.log("Creating job:", formData);
    setShowForm(false); // Close form after submit
  };

  const handleCopyJob = (jobToCopy) => {
    const copiedJob = {
      ...jobToCopy,
      id: undefined, // remove ID so it’s treated as new
      title: `${jobToCopy.title} (Copy)`,
    };
    navigate("/employer/job-management/new", { state: { copiedJob } });
  };

  const handleToggleStatus = async (jobId) => {
    try {
      const token = localStorage.getItem("otoken"); // or however you store your auth token

      const res = await jbAPI.put(
        `/employer/job/${jobId}/status`,
        {}, // No body needed
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (res.data.success) {
        // alert(res.data.message);
        setMessage({
          type: "info",
          text: res.data.message,
        });
        setJobs((prevJobs) =>
          prevJobs.map((job) =>
            job.job_id === jobId ? { ...job, status: "Deactivated" } : job
          )
        );
        // Optionally refresh jobs list or update UI
      }
    } catch (error) {
      console.error("Failed to change job status:", error);
      // alert("Something went wrong while updating job status.");
      setMessage({
        type: "info",
        text: "Something went wrong while updating job status.",
      });
    }
  };

  const handleDelete = async (jobId) => {
    // const confirmed = window.confirm("Are you sure you want to delete this job?");
    // if (!confirmed) return;

    try {
      const response = await jbAPI.delete(`/employer/job/${jobId}/delete`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('otoken')}`, // Adjust token storage method
        },
      });

      if (response.data.success) {
        alert("Job deleted successfully!");
        setJobs((prevJobs) => prevJobs.filter((job) => job.job_id !== jobId));
      }
    } catch (error) {
      console.error("Delete failed:", error);
      alert("Failed to delete job");
    }
  };

  return (
    <div className="content-body">
      <div className="container-fluid mt-3">
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                {message.text && (
                  <div
                    className={`alert alert-${message.type} mt-3`}
                    role="alert"
                  >
                    <button
                      type="button"
                      class="close"
                      data-dismiss="alert"
                      aria-label="Close"
                      onClick={() => setMessage({ text: "", type: "" })}
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                    {message.text}
                  </div>
                )}
                <div className="d-flex justify-content-between ">
                  <h4 className="card-title mb-0">Job Posts</h4>
                  <button
                    className="btn btn-lg btn-outline-primary"
                    title="New Job Post"
                    onClick={() => navigate("/employer/job-management/new")}
                  >
                    <i className="fa fa-plus-circle"></i>
                  </button>
                </div>

                <div className="table-responsive mt-2">
                  <table id="jobListTable" className="table table-striped table-bordered mt-2">
                    <thead className="text-center">
                      <tr>
                        <th>Job Code</th>
                        <th>Job Title</th>
                        <th>Location </th>
                        <th>Work Mode</th>
                        <th>Posted Date</th>
                        <th>Application Deadline </th>
                        <th>No. of Vaccancies </th>
                        <th>No. of Applicants </th>
                        <th>Status</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {jobs.map((job) => (
                        <tr key={job.job_id}>
                          <td>{job.job_code}</td>
                          <td>{job.title}</td>
                          <td>{job.job_location}</td>
                          <td>{job.work_mode}</td>
                          <td>{formatDateSafe(job.createdAt)}</td>
                          <td>{formatDateSafe(job.deadline)}</td>
                          <td>{job.no_of_vacancies}</td>
                          <td></td>
                          <td>{job.status}</td>
                          <td>
                            <button
                              className="btn btn-sm btn-outline-primary me-1 mr-2"
                              title="Edit"
                              onClick={() =>
                                navigate(
                                  `/employer/job-management/edit/${job.job_id}`
                                )
                              }
                            >
                              <i className="fa fa-pencil-square"></i>
                            </button>
                            <button
                              className="btn btn-sm btn-outline-warning me-1 mr-2"
                              title="Deactivate"
                              onClick={() => handleToggleStatus(job.job_id)}
                            >
                              <i className="fa fa-remove"></i>
                            </button>
                            {/* <button
                              className="btn btn-sm btn-outline-info me-1 mr-2"
                              title="View Applicants"
                            >
                              <i className="fa fa-eye"></i>
                            </button> */}
                            <button
                              className="btn btn-sm btn-outline-danger me-1 mr-2"
                              title="Delete"
                              onClick={() => handleDelete(job.job_id)}
                            >
                              <i className="fa fa-trash"></i>
                            </button>
                            <button
                              className="btn btn-sm btn-outline-secondary"
                              title="Copy Job Post"
                              onClick={() => handleCopyJob(job)}
                            >
                              <i className="fa fa-copy"></i>
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManageJobs;
